export const MarketingAttributionsFeatureFlags = {
  enabled: 'enable-marketing-attribution',
  demoEnabled: 'analytics-inbound-marketing-attribution:enable-demo',
};
